export default ({ axios, mapQueryString }) => ({
    index: (filters = {}) => axios.get(`/api/specializations${mapQueryString(filters)}`),
    show: (id) => axios.get(`/api/specializations/${id}`),
    store: (body) => axios.post(`/api/specializations`, body),
    update: (id, body) => axios.patch(`/api/specializations/${id}`, body),
    delete: (id) => axios.delete(`/api/specializations/${id}`),
    coordinator: (specialization_id, query = {}) => axios.get(`/api/specializations/${specialization_id}/coordinator${mapQueryString(query)}`),
    courses: (body = {}, filters = {}) => axios.post(`/api/specializations/periods/pensums/semesters/courses${mapQueryString(filters)}`, body)
})
